import { AppRegistry } from "react-native";
import { enableScreens } from "react-native-screens";
import App from "./App";
AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", { rootTag: document.getElementById("root") });
enableScreens();
